module.exports = __webpack_public_path__ + "static/media/29COICT5.b6123968.jpg";